import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RecaptchaModule, RECAPTCHA_SETTINGS, RECAPTCHA_LANGUAGE, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import { SolicitudComponent } from './components/solicitud/solicitud.component';
import { AutorizacionComponent } from './components/autorizacion/autorizacion.component';
import { ConsultaComponent } from './components//consulta/consulta.component';
import { ConsultaRuntComponent } from './components/consulta-runt/consulta-runt.component';

import { AutenticacionService } from '../shared/services/autenticacion.service';

import { SolicitudService } from './services/solicitud.service';
import { AutorizacionService } from './services/autorizacion.service';
import { ConsultaService } from './services/consulta.service';
import { ConsultaInternaService } from './services/consulta-interna.service';

import { environment } from '../../environments/environment';

import { SharedModule } from '../shared/shared.module';

import { AppRoutingModule } from '../app-routing.module';

@NgModule({
  declarations: [
    SolicitudComponent,
    AutorizacionComponent,
    ConsultaComponent,
    ConsultaRuntComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule
  ],
  providers: [
    AutenticacionService,
    SolicitudService,
    AutorizacionService,
    ConsultaService,
    ConsultaInternaService,
    { provide: RECAPTCHA_LANGUAGE, useValue: 'es', },
    // { provide: RECAPTCHA_SETTINGS, useValue: { siteKey: environment.reCaptchaSiteKey } as RecaptchaSettings, },
  ],
})
export class PublicModule { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/public.module.ts